var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F4F4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3635_26274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#5A81FA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3635_26274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3635_26274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 24,
    height: 26
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 24,
    height: 25.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3635_26274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 29.1667C12.45 29.1667 11.9792 28.96 11.5875 28.5465C11.1958 28.1331 11 27.6361 11 27.0556V12.2778C11 11.6972 11.1958 11.2003 11.5875 10.7868C11.9792 10.3734 12.45 10.1667 13 10.1667H27C27.55 10.1667 28.0208 10.3734 28.4125 10.7868C28.8042 11.2003 29 11.6972 29 12.2778V27.0556C29 27.6361 28.8042 28.1331 28.4125 28.5465C28.0208 28.96 27.55 29.1667 27 29.1667H13ZM13 27.0556H27V12.2778H13V27.0556ZM16 24.9445H21C21.2833 24.9445 21.5208 24.8433 21.7125 24.641C21.9042 24.4387 22 24.188 22 23.8889C22 23.5898 21.9042 23.3391 21.7125 23.1368C21.5208 22.9345 21.2833 22.8333 21 22.8333H16C15.7167 22.8333 15.4792 22.9345 15.2875 23.1368C15.0958 23.3391 15 23.5898 15 23.8889C15 24.188 15.0958 24.4387 15.2875 24.641C15.4792 24.8433 15.7167 24.9445 16 24.9445ZM16 20.7222H24C24.2833 20.7222 24.5208 20.6211 24.7125 20.4188C24.9042 20.2165 25 19.9658 25 19.6667C25 19.3676 24.9042 19.1169 24.7125 18.9146C24.5208 18.7123 24.2833 18.6111 24 18.6111H16C15.7167 18.6111 15.4792 18.7123 15.2875 18.9146C15.0958 19.1169 15 19.3676 15 19.6667C15 19.9658 15.0958 20.2165 15.2875 20.4188C15.4792 20.6211 15.7167 20.7222 16 20.7222ZM16 16.5H24C24.2833 16.5 24.5208 16.3989 24.7125 16.1965C24.9042 15.9942 25 15.7435 25 15.4445C25 15.1454 24.9042 14.8947 24.7125 14.6924C24.5208 14.4901 24.2833 14.3889 24 14.3889H16C15.7167 14.3889 15.4792 14.4901 15.2875 14.6924C15.0958 14.8947 15 15.1454 15 15.4445C15 15.7435 15.0958 15.9942 15.2875 16.1965C15.4792 16.3989 15.7167 16.5 16 16.5Z",
    fill: "#5A81FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.4e58e4e31db537d39525fb1859fc4bda.svg";
export { ForwardRef as ReactComponent };